import { CustomerTaskStatusEnum } from "./enum/customer-task-status-enum";
import { TaskPositionEnum } from "./enum/task-position-enum";

export class TaskSmall {
    id: number;
    jobId: number;
    title: string;
    description: string;
    createdDate: Date;
    createdBy: string;
    numberOfConsultants: number;
    taskPosition: TaskPositionEnum;
    deadline: Date;
    consultantRole: string;
    hasChosenProfiles: boolean;
    wonExternalPartner: string;
    customerName: string;
    accountManagerName: string;
    comment: string;
    customerTaskStatus: CustomerTaskStatusEnum;
    adminId: number;
    commentDate: Date;
    commentAdmin: string;
    updatedDate: Date;
    hasContract: boolean;
}
